<template>
  <div>
    <div class="page-title">Edit Text Block</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Text Block"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.text-blocks.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.TextBlock.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.TextBlock.update(this.form);
      this.$router.push("/widgets/text-blocks");
    },
  },
};
</script>

<style></style>
